/**
 * YCC Theme — assets/js/src/google-map-block.js
 *
 * Front-end runtime for the ycc/google-map block.
 *
 * @package YCC
 */

(function () {
  "use strict";

  const STYLE_PRESETS = {
    standard: null,
    bw: [
      {
        stylers: [{ saturation: -100 }, { lightness: 10 }],
      },
    ],
    silver: [
      {
        elementType: "geometry",
        stylers: [{ color: "#f5f5f5" }],
      },
      {
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ color: "#616161" }],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#f5f5f5" }],
      },
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#c9c9c9" }],
      },
    ],
    dark: [
      {
        elementType: "geometry",
        stylers: [{ color: "#212121" }],
      },
      {
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        elementType: "labels.text.fill",
        stylers: [{ color: "#757575" }],
      },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#212121" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }],
      },
    ],
  };

  function parseMarkers(markersJson) {
    console.log("markersJson:", markersJson);
    if (!markersJson) return [];

    try {
      const parsed = JSON.parse(markersJson);
      const markerList = Array.isArray(parsed)
        ? parsed
        : Object.values(parsed || {});
      if (!Array.isArray(markerList)) return [];

      return markerList
        .map(function (marker) {
          const lat = Number(marker.lat);
          const lng = Number(marker.lng);

          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

          return {
            lat: lat,
            lng: lng,
            title: marker.title || "",
          };
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function makeIconUrl(color) {
    var fill = color || "#EA4335";
    // Darken the fill slightly for a border/glyph contrast
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="27" height="43" viewBox="0 0 27 43">' +
      '<path fill="' +
      fill +
      '" stroke="#fff" stroke-width="1.5" d="M13.5 0C6.04 0 0 6.04 0 13.5 0 23.62 13.5 43 13.5 43S27 23.62 27 13.5C27 6.04 20.96 0 13.5 0z"/>' +
      '<circle fill="#fff" cx="13.5" cy="13.5" r="5.5"/>' +
      "</svg>";
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function initOneMap(el) {
    if (!window.google || !window.google.maps || el.dataset.mapReady === "1") {
      return;
    }
    //console.log("Initializing map for element:", el);
    const markers = parseMarkers(el.dataset.markers);
    const zoom = Number(el.dataset.zoom) || 12;
    const mapStyle = el.dataset.style || "standard";
    const mapId = el.dataset.mapId || "";
    const styles =
      !mapId && STYLE_PRESETS[mapStyle] ? STYLE_PRESETS[mapStyle] : null;
    const useAdvanced =
      mapId &&
      window.google.maps.marker &&
      window.google.maps.marker.AdvancedMarkerElement;

    const center = markers.length
      ? { lat: markers[0].lat, lng: markers[0].lng }
      : { lat: 0, lng: 0 };

    const mapOptions = {
      center: center,
      zoom: zoom,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
    };

    if (mapId) {
      mapOptions.mapId = mapId;
    } else {
      mapOptions.styles = styles;
    }

    const map = new window.google.maps.Map(el, mapOptions);

    if (!markers.length) {
      el.dataset.mapReady = "1";
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();

    markers.forEach(function (markerData) {
      const position = { lat: markerData.lat, lng: markerData.lng };
      console.log("useAdvanced : ", useAdvanced);
      console.log("Adding marker with markerData:", markerData);
      if (useAdvanced) {
        var pinContent;
        if (markerData.color) {
          console.log("creating pin with color:", markerData.color);
          var pinEl = new window.google.maps.marker.PinElement({
            background: markerData.color,
            borderColor: "#ffffff",
            glyphColor: "#ffffff",
          });
          pinContent = pinEl.element;
        }
        new window.google.maps.marker.AdvancedMarkerElement({
          position: position,
          map: map,
          title: markerData.title,
          content: pinContent,
        });
      } else {
        new window.google.maps.Marker({
          position: position,
          map: map,
          title: markerData.title,
          icon: markerData.color
            ? {
                url: makeIconUrl(markerData.color),
                scaledSize: new window.google.maps.Size(27, 43),
                anchor: new window.google.maps.Point(13, 43),
              }
            : undefined,
        });
      }

      bounds.extend(new window.google.maps.LatLng(position.lat, position.lng));
    });

    if (markers.length > 1) {
      map.fitBounds(bounds);
    }

    el.dataset.mapReady = "1";
  }

  function initAllMaps() {
    document.querySelectorAll(".ycc-google-map").forEach(initOneMap);
  }

  window.yccGoogleMapInitAll = initAllMaps;
  window.yccGoogleMapApiReady = initAllMaps;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllMaps);
  } else {
    initAllMaps();
  }
})();
